import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Box, Button, Group, Modal, Text } from '@mantine/core';
import { DateTimePicker, DateValue } from '@mantine/dates';
import { useState } from 'react';

import { useImportPage } from '../../../api/import';
import { Platform } from '../../../types';

type Props = {
  pageId: string;
  platform: Platform;
};

export const ImportPageModal = NiceModal.create(({ pageId, platform }: Props) => {
  const [date, setDate] = useState<DateValue>();
  const modal = useModal();

  const { mutate, isLoading } = useImportPage({ config: { onSuccess: modal.remove }, platform });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Import page history?"
    >
      <Box py={20}>
        <DateTimePicker
          label="Pick date and time"
          description="Will skip dialogs with activity earlier than selected date"
          placeholder="Pick date and time"
          clearable
          dropdownType="modal"
          pb={30}
          onChange={setDate}
          value={date}
        />
        <Group justify="right">
          {date && (
            <Text fz={12} opacity={0.7}>
              {date.toUTCString()}
            </Text>
          )}
          <Button
            onClick={() => {
              mutate({ pageId, importingFrom: date?.valueOf() });
            }}
            loading={isLoading}
          >
            Yes
          </Button>
          <Button onClick={modal.remove} variant="outline" color="red">
            No
          </Button>
        </Group>
      </Box>
    </Modal>
  );
});
